import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionPlanDiscountConnectionRoot } from "./discount-connection/root";
import { QuestionPlanDummyRoomConnection } from "./dummy-room-connection";
import { QuestionPlanMinAndMaxPeopleNum } from "./min-and-max-people-num";
import { QuestionPlanOptionConnectionRoot } from "./option-connection/root";
import { QuestionDayTripPlanRoomChangeDisable } from "./room-change-disable";

import type { DayTripPlanCategoriesAndManagerStore } from "../../store/categories";

type Props = {
	connection: DayTripPlanCategoriesAndManagerStore["connection"];
};

export const QuestionDayTripPlanConnection = ({ connection }: Props) => {
	return (
		<>
			<FeatureIslandMainWithCategoryWrapper islandTitle="部屋" categoryStore={connection}>
				<QuestionPlanDummyRoomConnection />
			</FeatureIslandMainWithCategoryWrapper>

			<FeatureIslandMainWithCategoryWrapper islandTitle="オプション" categoryStore={connection}>
				<QuestionPlanOptionConnectionRoot />
			</FeatureIslandMainWithCategoryWrapper>

			<FeatureIslandMainWithCategoryWrapper islandTitle="ディスカウント" categoryStore={connection}>
				<QuestionPlanDiscountConnectionRoot />
			</FeatureIslandMainWithCategoryWrapper>

			<FeatureIslandMainWithCategoryWrapper islandTitle="部屋に関する高度な設定" categoryStore={connection}>
				<QuestionDayTripPlanRoomChangeDisable />
				<QuestionPlanMinAndMaxPeopleNum />
			</FeatureIslandMainWithCategoryWrapper>
		</>
	);
};

QuestionDayTripPlanConnection.displayName = "QuestionDayTripPlanConnection";
